import type { BookingDTO } from '@/types/dto/agent';
import type { CheckoutValues } from '@/utils/zodSchema';

export type CheckoutPassenger = CheckoutValues['passengers'][number];

export type BookingPassenger = NonNullable<BookingDTO['passengers']>[number];

export type CheckoutOrBookingPassengerMap = Record<
  NonNullable<CheckoutPassenger['id'] | BookingPassenger['id']>,
  CheckoutPassenger | BookingPassenger
>;

export enum PassengerGenderOptions {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  X = 'X',
}
